import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    routeKey: 1,
    uploadData: null,
    keepAliveInclude: ['project-manage', 'domain-manage', 'user-manage'],
    menus: require('./menus.js').default,
    projectTypes: {
      normal: '普通项目',
      integration: '整合项目'
    },
    activeEnvs: {
      prod: '[or]中国生产环境',
      us_prod: '[or]美国生产环境',
      eu_prod: '[or]欧盟生产环境',
      xtool_dev: '[and]研发桌面'
    }
  },
  mutations: {
    routeReload(state) {
      state.routeKey++
    },
    setUploadData(state, payload) {
      state.uploadData = payload
    },
    setMenus(state, menus) {
      state.menus = menus
    }
  },
  getters: {
    langOptions(state) {
      var langOptions = []
      for (var key in state.langs) {
        langOptions.push({
          label: state.langs[key],
          value: key
        })
      }
      return langOptions
    },
    categoryOptions(state) {
      var categoryOptions = []
      for (var key in state.categorypg) {
        categoryOptions.push({
          label: state.categorypg[key],
          value: key
        })
      }
      return categoryOptions
    }
  },
  actions: {},
  modules: {}
})
